// Firebase import
import { db } from "../../constants/Firebase";
import {
  collection,
  addDoc,
  updateDoc,
  getDocs,
  query,
  doc,
  increment,
} from "firebase/firestore";

const dbTable = collection(db, "schools");

interface SchoolAddModel {
  schoolName: string;
  time: string;
  category: string;
}

const createSchool = async (school: SchoolAddModel) => {
  const { schoolName, time, category } = school;

  try {
    const docRef = await addDoc(dbTable, {
      schoolName: schoolName,
      time: time,
      category: category,
      breakoutOneSigns: 0,
      breakoutTwoSigns: 0,
      breakoutThreeSigns: 0,
      breakoutFourSigns: 0,
    });

    return { message: `School created with ID ${docRef.id}`, body: docRef.id };
  } catch (e) {
    return { message: `Error: ${e}`, body: null };
  }
};

const getSchools = async () => {
  const q = query(dbTable);
  const querySnapshot = await getDocs(q);
  let amSchools: any[] = [];
  let pmSchools: any[] = [];
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    if (doc.data().time === "AM") {
      amSchools.push({ ...doc.data(), id: doc.id });
    } else {
      pmSchools.push({ ...doc.data(), id: doc.id });
    }
  });
  return { amSchools, pmSchools };
};

const addSlots = async (schools: any[], userId: string, time: string) => {
  schools.forEach(async (school, index) => {
    const ref = doc(db, "schools", school.id);
    if (index === 0) {
      await updateDoc(ref, {
        breakoutOneSigns: increment(1),
      });
    } else if (index === 1) {
      await updateDoc(ref, {
        breakoutTwoSigns: increment(1),
      });
    } else if (index === 2) {
      await updateDoc(ref, {
        breakoutThreeSigns: increment(1),
      });
    } else if (index === 3) {
      await updateDoc(ref, {
        breakoutFourSigns: increment(1),
      });
    }
  });

  const ref = doc(db, "users", userId);
  console.log(schools);

  if (time === "AM") {
    let a = {
      amSessionsIds: [
        schools[0].id,
        schools[1].id,
        schools[2].id,
        schools[3].id,
      ],
      amSessionsNames: [
        schools[0].schoolName,
        schools[1].schoolName,
        schools[2].schoolName,
        schools[3].schoolName,
      ],
    }
    console.log(a)
    await updateDoc(ref, a);
  } else {
    let a = {
      pmSessionsIds: [
        schools[0].id,
        schools[1].id,
        schools[2].id,
        schools[3].id,
      ],
      pmSessionsNames: [
        schools[0].schoolName,
        schools[1].schoolName,
        schools[2].schoolName,
        schools[3].schoolName,
      ],
    }
    console.log(a)
    await updateDoc(ref, a);
  }
};

export { createSchool, getSchools, addSlots };
